import { useForm } from '@mantine/form';

import { managerTypes } from '../types';

type Props = {
  initialValues: { email?: string } & managerTypes.Manager['config'];
};

export const useManagerConfigForm = ({ initialValues }: Props) => {
  return useForm({
    initialValues: initialValues,

    validate: {
      isUsernamesVisible: (v) => {
        if (typeof v !== 'boolean') {
          return 'Wrong flag';
        }
      },
      isSystemMessagesVisible: (v) => {
        if (typeof v !== 'boolean') {
          return 'Wrong flag';
        }
      },
      isMessagesTranslationEnabled: (v) => {
        if (typeof v !== 'boolean') {
          return 'Wrong flag';
        }
      },
      email: (v) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (v && !emailRegex.test(v)) {
          return 'Invalid email address';
        }
      },
    },
  });
};
